export enum ForceUnit {
  NEWTON = 'NEWTON',
  POUND_FORCE = 'POUND_FORCE',
}
